import * as React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

class ColourComponent extends React.Component {

  getClassName (isSelected) {
    return (isSelected) 
      ? 'find-in-store-form__color-selector__circle__border--selected'
      : 'find-in-store-form__color-selector__circle__border';
  }
  
  render() {
    const {isSelected, colorHex, colorId, handleColorSelect} = this.props;
    return (
      <span className={this.getClassName(isSelected)}>
        <button
          style={{ backgroundColor: `${colorHex}` }}
          type="button"
          className="find-in-store-form__color-selector__circle"
          onClick={() => handleColorSelect(colorHex, colorId)}
        ></button>
      </span>
    );
  }
}

ColourComponent.propTypes = {
  isSelected: PropTypes.bool,
  colorHex: PropTypes.string,
  colorId: PropTypes.string,
  handleColorSelect: PropTypes.func
};

export default ColourComponent;
